import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'calendar',
    'day',
    'tmplMonth',
    'tmplWeek',
    'tmplDayContent',
    'calendarContainer',
    'datepickerContainer',
    'next',
    'previous',
    'options',
    'rest',
    'label',
  ]

  connect() {
    console.log(`Connect: ${this.identifier}`)
    this.dayClass = '[data-wizard--datepicker-target="day"]'
    ;(this.months = [
      'Januari',
      'Februari',
      'Maart',
      'April',
      'Mei',
      'June',
      'July',
      'Augustus',
      'September',
      'October',
      'November',
      'December',
    ]),
      this.createCalendar()
  }
  zeroPad(n, digits) {
    return n.toString().padStart(digits, '0')
  }
  createCalendar() {
    this.monthAhead = 30
    this.currentMonth = 0
    this.calendarContainerTarget.style.width = `${(this.monthAhead + 1) * 100}%`
    let d = new Date()

    this.calendarContainerTarget.style.width = `${this.monthAhead * 100}%`
    this.monthList = [...Array(this.monthAhead).keys()].map((m, i) => {
      this.calendarContainerTarget.appendChild(
        this.getMonth(
          i,
          new Date(d.getFullYear(), d.getMonth() + m, 1),
          new Date(d.getFullYear(), d.getMonth() + m + 1, 0)
        )
      )
    })
    this.dayTargets
      .find(
        (elem) =>
          elem.dataset.date ===
          `${d.getFullYear().toString().slice(-2)}${this.zeroPad(
            d.getMonth() + 1,
            2
          )}${this.zeroPad(d.getDate(), 2)}`
      )
      .classList.add('current-day')
  }
  getMonth(i, firstDate, lastDate) {
    const monthHTML = this.tmplMonthTarget.content.cloneNode(true)
    const table = monthHTML.querySelector('table')
    const header = monthHTML.querySelector('.calendar-header')
    const tbody = table.querySelector('tbody')
    const weekDaysArray = [...Array(7).keys()]
    weekDaysArray.map(() => {
      tbody.appendChild(this.tmplWeekTarget.content.cloneNode(true))
    })
    const cells = Array.from(monthHTML.querySelectorAll(this.dayClass)).filter(
      (_, i) => i >= firstDate.getDay() && i < lastDate.getDate() + firstDate.getDay()
    )
    cells.map((elem, i) => {
      const date = new Date(firstDate.getFullYear(), firstDate.getMonth(), i + 1)
      const strDate = `${date.getFullYear().toString().slice(-2)}${this.zeroPad(
        date.getMonth() + 1,
        2
      )}${this.zeroPad(date.getDate(), 2)}`
      elem.classList.add('calendar-day')
      elem.appendChild(this.tmplDayContentTarget.content.cloneNode(true))
      const a = elem.querySelector('a')
      const span = elem.querySelector('span')
      span.textContent = i + 1
      elem.dataset.date = strDate
      a.setAttribute('data-wizard--datepicker-date-param', strDate)
    })
    const width = 100 / this.monthAhead
    table.style.width = `${width}%`
    table.style.left = `${width * i}%`
    header.innerHTML = `${this.months[firstDate.getMonth()]}&nbsp;${firstDate.getFullYear()}`
    return monthHTML
  }
  selectDateHandler(e) {
    if (this.hasOptionsTarget) {
      const input = this.optionsTarget.querySelector('input')
      input.value = e.params.date
      this.fieldChanged()
    }
  }
  shortDateToHumanDate(shortDate) {
    return `${parseInt(shortDate.substr(4, 2))} ${
      this.months[parseInt(shortDate.substr(2, 2)) - 1]
    } 20${shortDate.substr(0, 2)}`
  }
  fieldChanged(sendForm = true) {
    const input = this.optionsTarget.querySelector('input')
    this.element.classList[input.value ? 'add' : 'remove']('selected')
    this.labelTarget.textContent = input.value
      ? this.shortDateToHumanDate(input.value)
      : this.labelTarget.dataset.label

    !input.value && this.dayTargets.map((elem) => elem.classList.remove('selected'))
    input.value &&
      this.dayTargets.find((elem) => elem.dataset.date === input.value).classList.add('selected')
    input.value && this.datepickerContainerTarget.classList.remove('open')

    sendForm &&
      document
        .querySelector('[data-controller="wizard--filter"]')
        .controllers['wizard--filter'].sendForm(true)
  }
  selectResetHandler() {
    if (this.hasOptionsTarget) {
      const input = this.optionsTarget.querySelector('input')
      input.value = ''
      this.fieldChanged()
    }
  }
  selectPreviousHandler() {
    this.currentMonth--
    this.setMonthContainer()
  }
  selectNextHandler() {
    this.currentMonth++
    this.setMonthContainer()
  }
  setMonthContainer() {
    this.previousTarget.classList[this.currentMonth <= 0 ? 'add' : 'remove']('disabled')
    this.nextTarget.classList[this.currentMonth + 1 >= this.monthAhead ? 'add' : 'remove'](
      'disabled'
    )
    this.calendarContainerTarget.style.left = `${this.currentMonth * -100}%`
  }
  selectOpenHandler() {
    this.datepickerContainerTarget.classList.toggle('open')
  }
  setDates(dateList) {
    this.unsetDates()
    this.dayTargets
      .filter((elem) => dateList.includes(parseInt(elem.dataset.date)))
      .map((elem) => elem.classList.remove('disabled'))
  }
  unsetDates() {
    this.dayTargets.map((elem) => elem.classList.add('disabled'))
  }
  optionsTargetConnected(target) {
    this.element.classList.remove('hide')
    const dateOptions = JSON.parse(target.dataset.options).filter((n) => n != 0)
    const input = this.optionsTarget.querySelector('input')
    console.log(input)
    if (dateOptions.length) {
      // input.value = dateOptions[0]
    } else {
      // input.value = ''
    }
    this.fieldChanged(false)
    this.setDates(dateOptions)
  }
  optionsTargetDisconnected(target) {
    this.element.classList.add('hide')
    // const input = this.optionsTarget.querySelector('input')
    // input.value = ''
    this.fieldChanged(false)
    this.setDates(JSON.parse(target.dataset.options).filter((n) => n != 0))
  }
}
